import React from "react";
import { enterpriseViewModel } from "common/viewModels";
import * as domain from "common/domain";
import * as animalUtils from "containers/BudgetHome/Animals/_utils";
import Watermark from "components/Watermark";

const FarmEntNumbers = ({ farm, budget, refData, showMobs }) => {
    const enterprises = enterpriseViewModel(farm, budget, refData);

    return (
        <React.Fragment>
            {enterprises.length === 0 && "There are no animal enterprises on this farm."}
            {enterprises.length > 0 && (
                <div className="Table Table-Compressed">
                    <Watermark />
                    <table className="Calendar">
                        <thead>
                            <tr className="Calendar-months">
                                <th className="Calendar-title">Name</th>
                                {domain.farmYear.map((m, i) => (
                                    <th key={i} className="u-textCenter">
                                        {m.substring(0, 3)}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {enterprises.map((e, x) => {
                                const cells = [
                                    <td data-width="25" key={"title"}>
                                        <span className="u-flex u-flexAlignItemsCenter">
                                            {e.icon && <img id={`calendar.titleIcon.${e.id}`} src={e.icon} className="u-mr-xs" width="35" height="35" alt={e.title} />}
                                            <span className="FarmTable-value">
                                                <span>{e.enterpriseType}</span>
                                            </span>
                                        </span>
                                    </td>,
                                ];
                                const mobs =
                                    showMobs &&
                                    e.mobs &&
                                    e.mobs.map((livestock, index) => {
                                        livestock.stockCounts = animalUtils.getStockCountsForMob(livestock);
                                        const livestockDetails = animalUtils.getLivestockDetails(livestock, refData);
                                        const startWeight = animalUtils.getStartWeight(livestock.events);
                                        const start = livestock.events.find((e) => e.eventType === "Starting" || e.month === "July");
                                        const age = start && start.ageInMonths;
                                        const { stockCounts = [], calvingDetails } = livestock;

                                        return (
                                            <React.Fragment key={index}>
                                                <tr className="tr-nested">
                                                    <td data-width="25">
                                                        {livestock.name}
                                                        <br />
                                                        <span className="Table-subtitle">Class: {livestockDetails.class}</span>
                                                        <span className="Table-subtitle"> | Breed: {livestockDetails.breed}</span>
                                                        {age ? <span className="Table-subtitle"> | Age: {age} months</span> : null}
                                                        {startWeight ? <span className="Table-subtitle"> | Start Weight: {startWeight}kg</span> : null}
                                                        {calvingDetails && calvingDetails.midCalvingDay && (
                                                            <div className="Table-subtitle">
                                                                Median calving date: {calvingDetails.midCalvingDay} {calvingDetails.midCalvingMonth}
                                                            </div>
                                                        )}
                                                        {calvingDetails && calvingDetails.dryDay && (
                                                            <div className="Table-subtitle">
                                                                Drying off date: {calvingDetails.dryDay} {calvingDetails.dryMonth}
                                                            </div>
                                                        )}
                                                    </td>
                                                    {stockCounts.map((stockCount) => (
                                                        <td key={stockCount.month} className={`u-textCenter ${stockCount.stockCount < 0 ? "u-textError" : ""}`}>
                                                            {stockCount.stockCount === 0 ? "-" : stockCount.stockCount}
                                                        </td>
                                                    ))}
                                                </tr>
                                            </React.Fragment>
                                        );
                                    });
                                switch (e.type) {
                                    case "Rsu":
                                        cells.push(
                                            <td colSpan="12" key={x}>
                                                <ul className="DataWidthTable FarmTable">
                                                    <li data-width="md-50" style={{ padding: "5px 20px" }}>
                                                        <span className="inline-key">Total RSU:</span>
                                                        <span className="inline-value">{e.totalRsu}</span>
                                                    </li>
                                                </ul>
                                            </td>
                                        );
                                        break;
                                    case "DairyPeak":
                                        cells.push(
                                            <td colSpan="12" key={x}>
                                                <ul className="DataWidthTable FarmTable">
                                                    <li data-width="md-33" style={{ padding: "5px 20px" }}>
                                                        <span className="inline-key">Peak number of cows milked:</span>
                                                        <span className="inline-value"> {e.peakCowsMilked}</span>
                                                    </li>
                                                    <li data-width="md-33" style={{ padding: "5px 20px" }}>
                                                        <span className="inline-key">AVERAGE MOB WEIGHT:</span>
                                                        <span className="inline-value"> {e.averageMobWeight ? `${e.averageMobWeight}kg` : "Use default"}</span>
                                                    </li>
                                                    {(e.calvingDetails || []).length > 0 && showMobs && (
                                                        <li data-width="md-33" style={{ padding: "5px 20px" }}>
                                                            <span className="inline-key">MOB CALVING:</span>
                                                            <span className="inline-value">
                                                                {(e.calvingDetails || []).map((c, i) => {
                                                                    return (
                                                                        <div key={i}>
                                                                            <span>Herd {i + 1}</span>{" "}
                                                                            {c.midCalvingDay && (
                                                                                <span>
                                                                                    - Median calving date: {c.midCalvingDay} {c.midCalvingMonth}
                                                                                </span>
                                                                            )}{" "}
                                                                            {c.dryDay && (
                                                                                <span>
                                                                                    | Drying off date: {c.dryDay} {c.dryMonth}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </span>
                                                        </li>
                                                    )}
                                                </ul>
                                            </td>
                                        );
                                        break;
                                    case "Other":
                                        cells.push(
                                            <td colSpan="12" key={x}>
                                                <ul className="DataWidthTable FarmTable">
                                                    {e.otherLivestockTotalsByType.map((livestock, index) => {
                                                        return (
                                                            <li key={index} data-width="md-25" style={{ padding: "5px 20px" }}>
                                                                <span className="inline-key">{livestock.type}:</span>
                                                                <span className="inline-value"> {livestock.number}</span>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            </td>
                                        );
                                        break;
                                    case "DairyReplacements":
                                        cells.push(
                                            <td colSpan="12" key={x}>
                                                <ul className="DataWidthTable FarmTable">
                                                    <li style={{ padding: "5px 20px" }}>
                                                        <span className="inline-key">Replacement grazing:</span>
                                                        <span className="inline-value"> {e.dairyReplacementGrazingMessage}</span>
                                                    </li>
                                                </ul>
                                            </td>
                                        );
                                        break;
                                    case "OutdoorPigs":
                                        cells.push(
                                            <td colSpan="12" key={x}>
                                                <ul className="DataWidthTable FarmTable">
                                                    <li style={{ padding: "5px 20px" }}>
                                                        <span className="inline-key">{e.growOutUnitOnly ? "Growers brought in per week: " : "Number of sows and mated gilts: "}</span>
                                                        <span className="inline-value">{e.growOutUnitOnly ? e.numbers.growersFinishers.broughtIn : e.numbers.sows.numberSowsMatedGilts}</span>
                                                    </li>
                                                </ul>
                                            </td>
                                        );
                                        break;
                                    default:
                                        e.slots.length > 0 &&
                                            domain.farmYear.forEach((calendarMonth, i) => {
                                                const slot = e.slots.find((slot) => slot.monthIndx === i) || e.slots.find((slot) => slot.month === calendarMonth);
                                                if (slot) {
                                                    cells.push(
                                                        <td key={`${x}_${i}`} className="u-textCenter">
                                                            {slot.icon && <img id={`calendar.${calendarMonth}.icon.${e.id}`} src={slot.icon} width={45} height={45} className="Calendar-icon" alt="Calendar icon" />}
                                                            {slot.iconText && (
                                                                <span id={`calendar.${calendarMonth}.iconText.${e.id}`} className="Calendar-icon-text">
                                                                    {slot.iconText}
                                                                </span>
                                                            )}
                                                            {slot.text && <span id={`calendar.${calendarMonth}.text.${e.id}`}>{slot.text}</span>}
                                                        </td>
                                                    );
                                                } else {
                                                    cells.push(<td key={`${x}_${i}`} className="Calendar-slot"></td>);
                                                }
                                            });
                                        break;
                                }
                                return (
                                    <React.Fragment key={x}>
                                        <tr>{cells}</tr>
                                        {showMobs && mobs}
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </React.Fragment>
    );
};

export default FarmEntNumbers;
